export const mergeOptions = <T>(options: T, defaults: any): T => {
    return Object.keys(defaults || {}).reduce((result, key) => {
        if (result[key] === undefined) {
            result[key] = defaults[key]
        }

        return result
    }, options || ({} as T))
}
